export default __webpack_public_path__ + "static/AuditPage-769699fd69756c9893e3051cd216542f.png";